<img [src]="eventObj.Images[0].Path">
